import React from 'react';
import './DrawerList.css';

const DrawerList = ({ options }) => {
  return (
    <ul className="drawer-list">
      {options.map((option, index) => (
        <li key={index} onClick={option.onClick}>
            <span className={"drawer-icon " + option.faIcon}/>
            {option.title}
        </li>
      ))}
    </ul>
  );
};

export default DrawerList;
